<template>
    <v-card>
    <v-card-title>
      <v-toolbar  flat outlined>
        <v-icon large right>fas fa-file-alt</v-icon>
        <v-toolbar-title class="pl-3">Services Request</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
      </v-toolbar>
    </v-card-title>
        <v-data-table
        v-on:inseteCliente="getAllRequest()"
        :headers="headers"
        :items="desserts"
        :search="search">
        <template v-slot:no-data v-if="desserts.length === 0">
                <v-progress-linear indeterminate color="green" v-if="waiting"></v-progress-linear>
                <v-alert dark class="text-xs-center" :value="true" type="warning" v-if="!waiting">No Data</v-alert>
            </template>
        <template v-slot:item.actions="{ item }">
            
            <v-tooltip bottom color="#00B40F">
                <template v-slot:activator="{ on }">
                    <v-btn  @click="SeeRequest(item)" icon color="orange" v-on="on">
                        <v-icon >far fa-eye</v-icon>
                    </v-btn>
                </template>
                <span>See</span>
            </v-tooltip>
        </template>
        
        <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
            Your search "{{ search }}" not have result.
            </v-alert>
        </template>
        
        </v-data-table>
        
        <!--DIALOG TO INPUT TOTAL -->
        <v-dialog v-model="dialogCustomer" width="600" persistent>
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                  Service Request
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="cantactModel.companyName" disabled label="Company Name*" outlined  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="cantactModel.typeWork" disabled flat label="Type of Work*" outlined ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="cantactModel.caseQuantity" disabled flat label="Case Quantity (Unloading/Loading only)*" outlined ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="cantactModel.date" disabled flat label="Date and time of appointment*" outlined ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="cantactModel.sku" disabled flat label="SKUS (Unloading Only)*" outlined ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="cantactModel.location" disabled flat label="Location*" outlined ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="cantactModel.email" flat  disabled label="Email*" outlined ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="cantactModel.phoneNumber" disabled flat label="Phone Number*"  outlined ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="cantactModel.message"  disabled flat  label="Message*"  outlined  ></v-textarea>
                </v-col>
              </v-row>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text @click="closeDialog()" outlined>
                    Cancel
                </v-btn>
                <v-btn color="success" text @click="markAsFinish()" outlined>
                    mark as finished
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import {showMessageError,showMessageSuccess,showMessageWarning} from '../../services/sweetAlert'
export default {
    data() {
        return {
            dialogCustomer:false,
            waiting:true,
            dialogTotal: false,
            search: '',
            desserts:[],
            headers: [
                { text: 'Company Name', align: 'left', value: 'companyName'},
                { text: 'Type of Work', align: 'center',  value: 'typeWork' },
                {text: 'Case Quantity', align:'center', value: 'caseQuantity'},
                {text: 'Location', align:'center', value: 'location'},
                {text: 'Date', align:'center', value: 'date'},
                { text: 'Action', value: 'actions',align: 'center', sortable: false }
            ],
            editedIndex: -1,
            //form
            valid: true,
            name: '',
            cantactModel:{
                companyName:'',
                typeWork:'',
                caseQuantity:'',
                date:'',
                sku:'',
                location:'',
                email:'',
                phoneNumber:'',
                message:''
            }
        }
    },
    mounted() {
        this.getAllRequest()
    },
    methods: {
        async markAsFinish(){
            var data =  {idFormContact: this.editedIndex}
            var response = await this.$store.dispatch('markAsFinish',data)
            if(response.status === 200){
                this.dialogCustomer=false
                showMessageSuccess('Request marked as completed successfully')
                this.getAllRequest()
            }else{
                showMessageError('An error sas occurred, please try again')
            }
        },
        closeDialog(){
            this.dialogCustomer = false
             this.$refs.form.reset()
             this.$refs.form.resetValidation()
        },
        async getAllRequest(){
            this.desserts =[]
            this.waiting = true
            const response = await this.$store.dispatch('getAllRequest',1)
            if(response.status === 200 ){
                this.desserts  = response.data
                this.waiting = false
            }else{
                showMessageError('An error occurred while loading customers')
            }
        },
        SeeRequest(item){
            this.dialogCustomer=true
            this.editedIndex = item.idFormContact
            this.cantactModel = Object.assign({}, item)
        }
    },
}
</script>